import { render, staticRenderFns } from "./Omne.vue?vue&type=template&id=7776c67a&scoped=true&"
import script from "./Omne.vue?vue&type=script&lang=js&"
export * from "./Omne.vue?vue&type=script&lang=js&"
import style0 from "./Omne.vue?vue&type=style&index=0&id=7776c67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7776c67a",
  null
  
)

export default component.exports